import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas", "clearButton", "generateButton", "form"]
  static values = { 
    userName: String
  }

  connect() {
    this.setupCanvas()
    this.setupEventListeners()
  }

  setupCanvas() {
    this.canvas = this.canvasTarget
    this.ctx = this.canvas.getContext('2d')
    this.isDrawing = false
    this.hasSignature = false
    
    // Set canvas size
    this.canvas.width = this.canvas.offsetWidth
    this.canvas.height = this.canvas.offsetHeight
    
    // Set canvas style
    this.ctx.strokeStyle = '#000000'
    this.ctx.lineWidth = 2
    this.ctx.lineCap = 'round'
  }

  setupEventListeners() {
    // Mouse events
    this.canvas.addEventListener('mousedown', this.startDrawing.bind(this))
    this.canvas.addEventListener('mousemove', this.draw.bind(this))
    this.canvas.addEventListener('mouseup', this.stopDrawing.bind(this))
    this.canvas.addEventListener('mouseout', this.stopDrawing.bind(this))
    
    // Touch events for mobile
    this.canvas.addEventListener('touchstart', this.startDrawing.bind(this))
    this.canvas.addEventListener('touchmove', this.draw.bind(this))
    this.canvas.addEventListener('touchend', this.stopDrawing.bind(this))
    
    // Form validation
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('submit', this.validateSignature.bind(this))
    }
  }

  startDrawing(e) {
    this.isDrawing = true
    this.hasSignature = true
    this.draw(e)
  }

  draw(e) {
    if (!this.isDrawing) return
    
    e.preventDefault()
    const rect = this.canvas.getBoundingClientRect()
    const x = (e.clientX || e.touches[0].clientX) - rect.left
    const y = (e.clientY || e.touches[0].clientY) - rect.top
    
    this.ctx.lineTo(x, y)
    this.ctx.stroke()
    this.ctx.beginPath()
    this.ctx.moveTo(x, y)
  }

  stopDrawing() {
    this.isDrawing = false
    this.ctx.beginPath()
  }

  clearSignature() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.hasSignature = false
  }

  generateTypedSignature() {
    const name = this.userNameValue || 'Sample Name'
    if (name) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx.font = '24px cursive'
      this.ctx.fillStyle = '#000000'
      this.ctx.textAlign = 'center'
      this.ctx.fillText(name, this.canvas.width / 2, this.canvas.height / 2 + 8)
      this.hasSignature = true
    }
  }

  validateSignature(e) {
    if (!this.hasSignature) {
      e.preventDefault()
      alert('Please provide a signature before submitting.')
      return false
    }
  }
}
